import { getController, apiService as Service } from '@/services/service'

const url = 'profile/notestype_favorites'

export const notesTypeFavoriteService = {
	...getController<Api.NoteTypeFavorite>(url),
	attachNoteFavorit: (userId: number, noteTypeId: number) =>
		Service.post({ url: `${url}/${noteTypeId}` }),
	detachNoteFavorit: (userId: number, noteTypeId: number) =>
		Service.delete({ url: `${url}/${noteTypeId}` }),
}
